import axios, { isAxiosError } from 'axios';

interface StreamConversationData {
  success: boolean;
  data: {
    session_id: string;
    conversation_id: string;
    user_token: string;
  };
}

interface StreamConversationResult {
  user: string;
  token: string;
  name: string;
  channelType: string;
  channelId: string;
}

interface StreamConversationParams {
  endpoint: string;
  secondaryOrgId: string;
  sessionId: string;
}

export async function getStreamConversation({
  endpoint,
  secondaryOrgId,
  sessionId,
}: StreamConversationParams): Promise<StreamConversationResult> {
  try {
    const chatSessionUrl = new URL('/api/v4/cms/public/chat/sessions', endpoint).toString();

    const params = {
      session_id: sessionId,
      secondary_organization_id: String(secondaryOrgId),
    };
    const { data } = await axios.post<StreamConversationData>(chatSessionUrl, params);
    return {
      user: data.data.session_id,
      token: data.data.user_token,
      name: 'Anonymous User',
      channelType: 'messaging',
      channelId: data.data.conversation_id,
    };
  } catch (e) {
    throw new Error(`Unexpected error: ${e instanceof Error ? e.message : 'Unknown error'}`);
  }
}

export async function deleteSession({ endpoint, secondaryOrgId, sessionId }: StreamConversationParams): Promise<void> {
  try {
    const chatSessionUrl = new URL('/api/v4/cms/public/chat/sessions', endpoint).toString();

    const params = {
      session_id: sessionId,
      secondary_organization_id: secondaryOrgId,
    };
    // use fetch with keepalive to ensure the request completes even after page unload
    // axios does not support keepalive
    await fetch(chatSessionUrl, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
      keepalive: true,
    });
  } catch (e) {
    // Silently fail on session deletion to avoid disrupting user experience
    console.warn('Failed to delete chat session:', e instanceof Error ? e.message : 'Unknown error');
  }
}
